(() => {
  const noteText = 'Shipping calculated at checkout.';
  const attribute = 'data-venja-shipping-note';
  const reassuranceText = 'Manage your subscription anytime from your account.';
  const reassuranceAttribute = 'data-venja-subscription-note';
  const styleId = 'venja-cart-note-style';
  const descriptionAttribute = 'data-venja-addon-description';
  const cardAttribute = 'data-venja-addon-card';
  const descriptions = new Map([
    ['gurls got gut', 'A daily powder with 14 live culture strains and prebiotic fibre.'],
    ['iron lady', 'An iron supplement for women who need additional iron alongside their Venja daily pack.']
  ]);
  let currentRoot = null;
  let observer = null;

  function styleNote(root) {
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `footer .dynamic-richtext p[${attribute}],
      footer .dynamic-richtext p[${reassuranceAttribute}] {
        font-size: 14px;
        line-height: 1.4;
        font-weight: 400;
        color: #5F5750;
      }
      [${cardAttribute}] {
        display: grid;
        grid-template-columns: 48px minmax(0, 1fr);
        column-gap: 12px;
        row-gap: 10px;
      }
      [${cardAttribute}] > img {
        width: 48px;
        height: 48px;
        margin-right: 0;
        object-fit: contain;
      }
      [${cardAttribute}] > div {
        min-width: 0;
      }
      [${cardAttribute}] > div > div {
        flex-wrap: wrap;
      }
      p[${descriptionAttribute}] {
        grid-column: 1 / -1;
        min-width: 0;
        margin: 0;
        font-size: 12px;
        line-height: 1.45;
        font-weight: 400;
        color: #5F5750;
        overflow-wrap: anywhere;
      }
        #cart-drawer [role="listitem"] > .flex.items-center {
          align-items: flex-start;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > img {
          flex-shrink: 0;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > .w-full {
          flex: 1;
          width: auto;
          min-width: 0;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > .w-full > .flex.justify-between:first-child {
          flex-direction: column;
          min-width: 0;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > .w-full > .flex.justify-between:first-child > div {
          min-width: 0;
          max-width: 100%;
          overflow-wrap: anywhere;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > .w-full > .flex.justify-between:first-child > .text-right {
          white-space: normal;
          text-align: left;
        }
        #cart-drawer [role="listitem"] > .flex.items-center > .w-full > .flex.justify-between:first-child > .text-right > div {
          white-space: normal;
          text-align: left;
        }
        #cart-drawer [role="listitem"] [part~="money"] {
          display: inline-block;
          white-space: nowrap;
        }`;
      root.appendChild(style);
    }
    root.querySelectorAll(`footer .dynamic-richtext p, [${attribute}], [${reassuranceAttribute}]`).forEach((paragraph) => {
      const plainFooter = paragraph.matches('footer .dynamic-richtext p') && paragraph.childElementCount === 0;
      [[attribute, noteText], [reassuranceAttribute, reassuranceText]].forEach(([marker, text]) => {
        const matches = plainFooter && paragraph.textContent.trim() === text;
        if (matches && !paragraph.hasAttribute(marker)) {
          paragraph.setAttribute(marker, '');
        } else if (!matches && paragraph.hasAttribute(marker)) {
          paragraph.removeAttribute(marker);
        }
      });
    });
  }

  function describeCards(root) {
    root.querySelectorAll('#cart-drawer div.rounded-storefront-drawer').forEach((card) => {
      const title = card.querySelector('div.font-semibold');
      const image = card.querySelector('img');
      const name = title?.textContent.trim().toLowerCase();
      const description = descriptions.get(name);
      const matches = description && image?.alt.trim().toLowerCase() === name &&
        card.querySelectorAll('button').length === 1;
      let paragraph = card.querySelector(`p[${descriptionAttribute}]`);
      if (!matches) {
        paragraph?.remove();
        if (card.hasAttribute(cardAttribute)) card.removeAttribute(cardAttribute);
        return;
      }
      if (!card.hasAttribute(cardAttribute)) card.setAttribute(cardAttribute, '');
      if (!paragraph) {
        paragraph = document.createElement('p');
        paragraph.setAttribute(descriptionAttribute, '');
        card.appendChild(paragraph);
      }
      if (paragraph.textContent !== description) paragraph.textContent = description;
    });
  }

  function update(root) {
    styleNote(root);
    describeCards(root);
  }

  function connect() {
    const root = document.getElementById('recharge-storefront-experiences__cart-drawer')?.shadowRoot;
    if (root === currentRoot) return;
    observer?.disconnect();
    observer = null;
    currentRoot = root || null;
    if (!root) return;
    update(root);
    observer = new MutationObserver(() => update(root));
    observer.observe(root, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['alt']
    });
  }

  connect();
  let timer = window.setInterval(connect, 1000);
  window.addEventListener('pagehide', () => {
    window.clearInterval(timer);
    observer?.disconnect();
    observer = null;
    currentRoot = null;
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      connect();
      timer = window.setInterval(connect, 1000);
    }
  });
})();
